// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IOrganizationAddressInfoDto
 */
export interface IOrganizationAddressInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IOrganizationAddressInfoDto
     */
    id?: number | null;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationAddressInfoDto
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationAddressInfoDto
     */
    line2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationAddressInfoDto
     */
    line3?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationAddressInfoDto
     */
    line4?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationAddressInfoDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationAddressInfoDto
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationAddressInfoDto
     */
    zipcode: string;
    /**
     * 
     * @type {boolean}
     * @memberof IOrganizationAddressInfoDto
     */
    preferred: boolean;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationAddressInfoDto
     */
    country_id: number;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationAddressInfoDto
     */
    address_type: IOrganizationAddressInfoDtoAddressTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IOrganizationAddressInfoDto
     */
    preferred_mailing?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOrganizationAddressInfoDto
     */
    preferred_physical?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof IOrganizationAddressInfoDto
     */
    valid_from?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof IOrganizationAddressInfoDto
     */
    valid_to?: Date | null;
}

/**
* @export
* @enum {string}
*/
export enum IOrganizationAddressInfoDtoAddressTypeEnum {
    PO_BOX = 'PO_BOX',
    RESIDENTIAL = 'RESIDENTIAL',
    BUSINESS = 'BUSINESS',
    UNKNOWN = 'UNKNOWN'
}


/**
 * Check if a given object implements the IOrganizationAddressInfoDto interface.
 */
export function instanceOfIOrganizationAddressInfoDto(value: object): value is IOrganizationAddressInfoDto {
    if (!('line1' in value) || value['line1'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('zipcode' in value) || value['zipcode'] === undefined) return false;
    if (!('preferred' in value) || value['preferred'] === undefined) return false;
    if (!('country_id' in value) || value['country_id'] === undefined) return false;
    if (!('address_type' in value) || value['address_type'] === undefined) return false;
    return true;
}

export function IOrganizationAddressInfoDtoFromJSON(json: any): IOrganizationAddressInfoDto {
    return IOrganizationAddressInfoDtoFromJSONTyped(json, false);
}

export function IOrganizationAddressInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOrganizationAddressInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'line1': json['line1'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'line3': json['line3'] == null ? undefined : json['line3'],
        'line4': json['line4'] == null ? undefined : json['line4'],
        'city': json['city'],
        'state': json['state'],
        'zipcode': json['zipcode'],
        'preferred': json['preferred'],
        'country_id': json['country_id'],
        'address_type': json['address_type'],
        'preferred_mailing': json['preferred_mailing'] == null ? undefined : json['preferred_mailing'],
        'preferred_physical': json['preferred_physical'] == null ? undefined : json['preferred_physical'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
    };
}

export function IOrganizationAddressInfoDtoToJSON(json: any): IOrganizationAddressInfoDto {
    return IOrganizationAddressInfoDtoToJSONTyped(json, false);
}

export function IOrganizationAddressInfoDtoToJSONTyped(value?: IOrganizationAddressInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'line1': value['line1'],
        'line2': value['line2'],
        'line3': value['line3'],
        'line4': value['line4'],
        'city': value['city'],
        'state': value['state'],
        'zipcode': value['zipcode'],
        'preferred': value['preferred'],
        'country_id': value['country_id'],
        'address_type': value['address_type'],
        'preferred_mailing': value['preferred_mailing'],
        'preferred_physical': value['preferred_physical'],
        'valid_from': value['valid_from'] === null ? null : ((value['valid_from'] as any)?.toISOString()),
        'valid_to': value['valid_to'] === null ? null : ((value['valid_to'] as any)?.toISOString()),
    };
}

